"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../../ApiManagerAdmin");
var ApiConfig_1 = require("../../config/ApiConfig");
/**
 * 매출통계 api
 */
var ApiPayment = /** @class */ (function (_super) {
    __extends(ApiPayment, _super);
    function ApiPayment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_PAYMENT_TIME_SALES = "/api/statistics/userPaymentHour";
        _this.GET_PAYMENT_DAY_SALES = "/api/statistics/userPaymentDate";
        _this.GET_PAYMENT_FRIST_PAYMENT_SALES = "/api/statistics/userPaymentFirst";
        _this.GET_PAYMENT_PAYMENT_LOGS = "/api/statistics/logPayment";
        _this.GET_PAYMENT_COUNTRY_SALES = "/api/statistics/paymentByCountry";
        _this.GET_DISCOUNT_COUPON_DATE = "/api/statistics/discountCouponByDate";
        /**
         * 시간대별 코인 소진 내역
         * @param accesstoken
         * @param date
         * @param timezone
         * @returns
         */
        _this.getPaymentTimeSales = function (accesstoken, date, timezone) {
            var data = {
                date: date,
                timezone: timezone,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_PAYMENT_TIME_SALES,
                data: data,
            });
        };
        /**
         * 일별 매출 - 일자별
         * @param accesstoken
         * @param req
         * @returns
         */
        _this.getPaymentDaySales = function (accesstoken, req) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_PAYMENT_DAY_SALES,
                data: req,
            });
        };
        /**
         * 일별 매출 - 첫결제
         * @param accesstoken
         * @param req
         * @returns
         */
        _this.getPaymentFirstPaymentSales = function (accesstoken, req) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_PAYMENT_FRIST_PAYMENT_SALES,
                data: req,
            });
        };
        /**
         * 전체 결제 내역
         * @param accesstoken
         * @param req
         * @returns
         */
        _this.getPaymentLogs = function (accesstoken, req) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_PAYMENT_PAYMENT_LOGS,
                data: req,
            });
        };
        /**
         * 국가별 매출
         * @param accesstoken
         * @param req
         * @returns
         */
        _this.getPaymentCountrySales = function (accesstoken, req) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_PAYMENT_COUNTRY_SALES,
                data: req,
            });
        };
        /**
         * 할인쿠폰 통계
         * @param accesstoken
         * @param req
         * @returns
         */
        _this.getDiscountCouponDate = function (accesstoken, req) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_DISCOUNT_COUPON_DATE,
                data: req,
            });
        };
        return _this;
    }
    ApiPayment.getInstance = function (initValue) {
        if (!ApiPayment.classInstance) {
            this.classInstance = new ApiPayment(initValue);
        }
        return this.classInstance;
    };
    return ApiPayment;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiPayment;
